export default {
  methods: {
    vNodeFilter: function(vNode) {
      return (vNode.tag != undefined);
    }
  }
};
